var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"quillEditorBox",staticClass:"quill-editor",class:{
    'quill-fullscreen': _vm.isFullscreen,
    'quill-no-border': !_vm.hasBorder,
    'disabled': _vm.disabled
  },style:({
    width: _vm.isFullscreen ? '' : _vm.width + 'px',
    height: _vm.isFullscreen ? '' : _vm.height + 'px',
    zIndex: _vm.zIndex
  })},[_c('div',{ref:"quillEditor"}),_vm._v(" "),_c('input',{ref:"img-input",staticStyle:{"display":"none"},attrs:{"type":"file","accept":_vm.imgAccept}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d2a1e4e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/quill-editor/quill-editor.vue
// module id = null
// module chunks = 